export class ApiAddCardModel {
  cardId?: number;
  cardNo: string;
  customerHostCode?: string;
  sourceSystemId?: number;
  vCustomerId: number;
  customerHostId: number;
  storeHostCode: string;
  channelCode: string;
}



// WEBPACK FOOTER //
// ./src/app/models/api-add-card.model.ts